export const helpData = [
  {
    heading: "General Questions",
    quesAns: [
      {
        q: "Q1: What is Film Help Squad?",
        ans: "Film Help Squad is a platform dedicated to the world of filmmaking. We provide a space for filmmakers, actors, writers, and industry professionals to connect, collaborate, and access resources to enhance their craft.",
      },
      {
        q: "Q2: How do I get started on Film Help Squad?",
        ans: "Getting started is easy! Simply create an account, complete your profile, and you'll be able to explore job listings, connect with fellow creatives, and start collaborating on film projects.",
      },
      {
        q: "Q3: Is Film Help Squad free to use?",
        ans: "Yes, our basic services are free to use. However, we also offer premium memberships with additional features and benefits for those looking to enhance their experience.",
      },
    ],
  },
  {
    heading: "Using the Platform ",
    quesAns: [
      {
        q: "Q4: Can I post my own film project on Film Help Squad?",
        ans: "Absolutely! You can create and post your film project on our platform and invite other members to collaborate with you.",
      },
      {
        q: "Q5: How can I find job listings or casting calls?",
        ans: "You can browse our job listings and casting calls by category and location. Use our search filters to narrow down your options and find the perfect opportunity.",
      },
      {
        q: "Q6: How do I connect with other members?",
        ans: "You can send connection requests to other members or accept incoming requests. Once connected, you can message each other and explore potential collaborations. ",
      },
    ],
  },
  {
    heading: "Privacy and Security",
    quesAns: [
      {
        q: "Q7: Is my personal information safe on Film Help Squad?",
        ans: "We take your privacy seriously. Your personal information is safeguarded in accordance with our Privacy Policy. We do not share your information without your consent.",
      },
      {
        q: "Q8: What should I do if I encounter inappropriate content or behavior on the platform?",
        ans: "Please report any inappropriate content or behavior to our support team immediately. We have strict guidelines and policies in place to maintain a safe and respectful community.",
      },
    ],
  },
  {
    heading: "Support and Assistance",
    quesAns: [
      {
        q: "Q9: How can I contact Film Help Squad for assistance?",
        ans: `You can reach our support team by visiting the "Contact Us" page and filling out the contact form. We'll get back to you as soon as possible.`,
      },
      {
        q: "Q10: What do I do if I forget my password or have trouble accessing my account?",
        ans: `No worries! You can reset your password using the "Forgot Password" link on the login page. If you need further assistance, contact our support team, and we'll help you regain access.`,
      },
    ],
  },
];
